<template>
  <span class="AssetIcon">
    <cryptoicon v-if="fontHasIcon" :symbol="uSymbol" :size="size" />
    <img
      v-else
      :src="
        asset.rid
          ? `https://s2.coinmarketcap.com/static/img/coins/64x64/${asset.rid}.png`
          : cointrackrLogo
      "
      :style="`width:${size}px;height:${size}px;`"
      class="AssetIcon__img"
    />
  </span>
</template>

<script>
import { mapGetters } from "vuex";
import cointrackrLogoNight from "@/static/touch-icon.png";
const icons = require("vue-cryptoicon/src/icons").default;

export default {
  name: "AssetIcon",
  props: {
    asset: {
      type: Object,
      required: true,
    },
    size: {
      type: Number,
      default: 24,
    },
  },
  computed: {
    uSymbol() {
      return this.asset.symbol.trim().toUpperCase();
    },
    lSymbol() {
      return this.uSymbol.toLowerCase();
    },
    fontHasIcon() {
      const { uSymbol, lSymbol } = this;
      return (
        this.coins.filter(
          (i) => i.symbol === uSymbol || i.symbol === uSymbol + " "
        ).length == 1 && icons.findIndex((i) => i.symbol === lSymbol) > -1
      );
    },
    cointrackrLogo() {
      return this.nightMode ? cointrackrLogoNight : "/favicon-not-empty.png";
    },
    ...mapGetters({
      coins: "coinmarketcap/coins",
      nightMode: "settings/nightMode",
    }),
  },
};
</script>

<style>
.AssetIcon__img {
  user-select: none;
}
</style>
